import { isPresent } from 'utils/isPresent';
import React, { Component } from 'react';
import GoogleMap from 'google-map-react';
import HCMapStyleDetails from './HCMapStyleDetails.js';
import HCMapModel from './HCMapModel';
import { isEqual } from 'lodash-es';
import { isBlank } from 'utils/isBlank';
import { googleRef } from 'external-libs/googleMaps';

export default class HCMap extends Component {
  constructor(props) {
    super(props);
    this.map = null;
    this.mapModel = new HCMapModel();

    this.styleId = 'map_style';
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps !== this.props && googleRef.maps) {
      this.updateMap(this.props, newProps);
    }
  }

  componentDidUpdate() {
    if (isPresent(this.map) && isPresent(this.props.fitToMarkers)) {
      this.fitMapToMarkers();
    }
  }

  fitMapToMarkers() {
    let bounds = new googleRef.maps.LatLngBounds();

    this.props.markers.map((markerInfo) => {
      bounds.extend(markerInfo.position);
    });

    this.map.fitBounds(bounds);
  }

  onGoogleApiLoaded(googleMap) {
    this.map = googleMap;
    this.addHCProStyle();
    this.updateMap({}, this.props);
  }

  updateMap(preProps, newProps) {
    if (!isEqual(preProps.markers, newProps.markers)) {
      this.mapModel.updateMarkers(newProps.markers, this.map);
    }
    if (!isEqual(preProps.directions, newProps.directions)) {
      this.mapModel.updateDirections(newProps.directions, this.map);
    }
    if (!isEqual(preProps.circles, newProps.circles)) {
      this.mapModel.updateCircle(newProps.circles, this.map);
    }
  }

  addHCProStyle() {
    if (isBlank(this.map)) {
      return;
    }

    let styledMapType = new googleRef.maps.StyledMapType(HCMapStyleDetails, { name: 'HCP Map' });
    this.map.mapTypes.set(this.styleId, styledMapType);

    if (isPresent(this.props.fitToMarkers)) {
      this.fitMapToMarkers();
    }
  }

  render() {
    const mapCenter =
      isPresent(this.props.center) && isPresent(this.props.center.lat) && isPresent(this.props.center.lng)
        ? this.props.center
        : { lat: 0, lng: 0 };

    const mapOptions = {
      zoomControl: this.props.showZoomControl !== undefined ? this.props.showZoomControl : true,
      zoomControlOptions: {
        style: 2,
      },
      scrollwheel: this.props.scrollwheel !== undefined ? this.props.scrollwheel : false,
      mapTypeId: this.styleId,
      mapTypeControl: this.props.showMapControl !== undefined ? this.props.showMapControl : true,
      mapTypeControlOptions: {
        mapTypeIds: ['roadmap', 'hybrid', this.styleId],
      },
      fullscreenControl: this.props.fullscreenControl !== undefined ? this.props.fullscreenControl : false,
    };
    return (
      <div style={isPresent(this.props.mapContainerStyle) ? this.props.mapContainerStyle : {}}>
        <GoogleMap
          options={mapOptions}
          center={mapCenter}
          defaultZoom={isPresent(this.props.defaultZoom) ? this.props.defaultZoom : 10}
          zoom={this.props.zoom}
          yesIWantToUseGoogleMapApiInternals={true}
          onGoogleApiLoaded={(googleMapInfo) => {
            this.onGoogleApiLoaded(googleMapInfo.map);
          }}
        ></GoogleMap>
      </div>
    );
  }
}
